import React, { useState, useEffect } from 'react';
import axios from 'packs/axios';

// TODO: use axios wrapper in r5oa
axios.defaults.headers.common['X-CSRF-Token'] = document.querySelector(
  'meta[name="csrf-token"]',
).content;

const TrustpilotCompanyInfo = ({ score }) => {
  const [total, setTotal] = useState(0);
  const [stringRating, setStringRating] = useState('');
  const [starImage, setStarImage] = useState(undefined);
  const [noCompanyScore, setNoComapnyStore] = useState(false);
  const [loading, setLoading] = useState(false);

  const getCompanyScore = () => {
    setLoading(true);
    axios
      .get('/trustpilot/summary_data', {
        headers: {
          'Content-Type': 'text/javascript',
          Accept: 'text/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
      .then(({ data }) => {
        const {
          review_count: pTotal,
          string_rating: pStringRating,
          star_image: pStarImage,
        } = data;
        setTotal(pTotal);
        setStringRating(pStringRating);
        setStarImage(pStarImage);
        setLoading(false);
      })
      .catch(() => {
        setNoComapnyStore(true);
        setLoading(false);
      });
  };

  useEffect(() => {
    getCompanyScore();
  }, []);

  if (noCompanyScore) {
    return (
      <div className="fl fl-col ai-c jc-c">
        <p>We are unable to get the information at this time.</p>
        <p>Please refresh to try again.</p>
      </div>
    );
  }

  return (
    <div className="fl fl-col ai-c jc-c">
      <p className="lf">Our customers say</p>
      <div className="company-score">
        <p className="main-score" data-testid="company-score">
          {stringRating}
          <span className="number-score">{score}</span>
          <span className="out-of">/5</span>
        </p>
      </div>
      {loading ? (
        <span className="loading" data-testid="loading">
          <i className="icon-spinner icon-spin icon-large" />
        </span>
      ) : (
        <a
          href="https://uk.trustpilot.com/review/cef.co.uk"
          rel="nofollow noopener noreferrer"
          target="_blank">
          <img className="trustpilot-stars" alt="stars" src={starImage} />
        </a>
      )}

      <p className="side-content" data-testid="total-review-count">
        Based on <strong>{total}</strong> reviews
      </p>
    </div>
  );
};

export default TrustpilotCompanyInfo;
